import type { IconNode } from '../types';

/**
 * @name cauldron
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSI4IiBjeT0iMy41IiByPSIuNSIgLz4KICA8Y2lyY2xlIGN4PSIxNCIgY3k9IjYiIHI9IjIiIC8+CiAgPHBhdGggZD0iTTE5IDJoLjAxIiAvPgogIDxwYXRoIGQ9Ik0yMiA4SDIiIC8+CiAgPHBhdGggZD0iTTcgMTJWOCIgLz4KICA8cGF0aCBkPSJNMTEgMTBWOCIgLz4KICA8cGF0aCBkPSJNNC40IDhDMi45IDkuNSAyIDExLjQgMiAxMy41IDIgMTguMiA2LjUgMjIgMTIgMjJzMTAtMy44IDEwLTguNWMwLTIuMS0uOS00LTIuNC01LjUiIC8+CiAgPHBhdGggZD0ibTUgMjAtMSAyIiAvPgogIDxwYXRoIGQ9Im0xOSAyMCAxIDIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/cauldron
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const cauldron: IconNode = [
  ['circle', { cx: '8', cy: '3.5', r: '.5', key: 'snt5uh' }],
  ['circle', { cx: '14', cy: '6', r: '2', key: '1m03mk' }],
  ['path', { d: 'M19 2h.01', key: 'rnvxl6' }],
  ['path', { d: 'M22 8H2', key: 'ysyahh' }],
  ['path', { d: 'M7 12V8', key: '17vupn' }],
  ['path', { d: 'M11 10V8', key: '487cu0' }],
  [
    'path',
    {
      d: 'M4.4 8C2.9 9.5 2 11.4 2 13.5 2 18.2 6.5 22 12 22s10-3.8 10-8.5c0-2.1-.9-4-2.4-5.5',
      key: '1dobco',
    },
  ],
  ['path', { d: 'm5 20-1 2', key: '13988j' }],
  ['path', { d: 'm19 20 1 2', key: '1piwgg' }],
];

export default cauldron;
